import { ORDER_BY } from "~/common/constants";

export const CONSULTATION_REQUESTS_TABLE_COLUMN_IDS = {
  name: "name",
  consultationStatus: "consultationStatus",
  primaryProvider: "primaryProvider",
  source: "source",
  state: "state",
  lastUpdated: "lastUpdated",
  actions: "actions",
} as const;

export type ConsultationRequestsTableColumnId =
  (typeof CONSULTATION_REQUESTS_TABLE_COLUMN_IDS)[keyof typeof CONSULTATION_REQUESTS_TABLE_COLUMN_IDS];

export const COLUMN_ID_TO_ORDER_BY: Record<
  Exclude<ConsultationRequestsTableColumnId, "actions">,
  (typeof ORDER_BY)[keyof typeof ORDER_BY]
> = {
  [CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.name]: ORDER_BY.lastName,
  [CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.consultationStatus]:
    ORDER_BY.consultationStatus,
  [CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.primaryProvider]: ORDER_BY.provider,
  [CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.source]: ORDER_BY.invitationLink,
  [CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.state]: ORDER_BY.state,
  [CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.lastUpdated]: ORDER_BY.feed,
};

const orderByToColumnId = Object.entries(COLUMN_ID_TO_ORDER_BY).map(
  ([columnId, orderBy]) => [orderBy, columnId] as const,
);

export const ORDER_BY_TO_COLUMN_ID = Object.fromEntries(
  orderByToColumnId,
) as Record<string, Exclude<ConsultationRequestsTableColumnId, "actions">>;

export const getOrderByFromColumnId = (
  columnId: string,
): (typeof ORDER_BY)[keyof typeof ORDER_BY] | undefined =>
  COLUMN_ID_TO_ORDER_BY[
    columnId as Exclude<ConsultationRequestsTableColumnId, "actions">
  ];

export const getColumnIdFromOrderBy = (
  orderBy: string,
): Exclude<ConsultationRequestsTableColumnId, "actions"> | undefined =>
  ORDER_BY_TO_COLUMN_ID[orderBy];
